/**
 * This emitter is used for sending synthetic native events to listeners
 * registered in the API layer with `NativeEventEmitter`.
 */
export { default } from 'react-native/Libraries/EventEmitter/RCTDeviceEventEmitter';
